/**
 * Shared TanStack Query client (8.13 "Ma'lumot olish": cache, background refresh, retry). An expired session
 * (401 on any request) sends the user back to the login page.
 */
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isApiError, shouldRetryRequest } from '../api/api_error';

export function createAppQueryClient(onUnauthenticated: () => void = () => undefined): QueryClient {
  const handleRequestError = (requestError: unknown) => {
    if (isApiError(requestError) && requestError.isUnauthenticated) {
      onUnauthenticated();
    }
  };
  return new QueryClient({
    queryCache: new QueryCache({ onError: handleRequestError }),
    mutationCache: new MutationCache({ onError: handleRequestError }),
    defaultOptions: {
      queries: {
        retry: shouldRetryRequest,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
      mutations: { retry: false },
    },
  });
}
